// extracted by mini-css-extract-plugin
export default {"shareButton":"ReportShareButton-shareButton-8669301ccf11684ca50a170a84d450a5"};